import { useIntl } from 'react-intl';
import { KTIcon, checkIsActive } from '../../../helpers';
import { AsideMenuItemWithSub } from './AsideMenuItemWithSub';
import { AsideMenuItem } from './AsideMenuItem';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { AsideMenuItemWithSubWithLink } from './AsideMenuItemWithSubWithLink';
import clsx from 'clsx';
import { useUserAuthStore } from '../../../../app/stores/userAuthStore';

export function AsideMenuMain() {
  const intl = useIntl();
  const navigate = useNavigate();
  const { user } = useUserAuthStore();

  const { id } = useParams();

  const { pathname } = useLocation();

  const checkSubMenu = (url: string) => {
    return checkIsActive(pathname, url);
  };

  const scroll = (id: string) => {
    const section = document.querySelector(id);
    (section as Element).scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  // Function to change only the last part of the path
  const changeLastPath = (newLastPath) => {
    const currentPathParts = location.pathname.split('/');
    // Replace the last part with the newLastPath
    currentPathParts[currentPathParts.length - 1] = newLastPath;
    const newPath = currentPathParts.join('/');
    navigate(newPath);
  };

  if (user.role.toLowerCase() === 'content uploader') {
    return (
      <>
        <AsideMenuItemWithSub to="/content" title="Content" icon="burger-menu">
          {checkSubMenu('/content/video/') &&
          !checkSubMenu('/content/video/video-list') ? (
            <AsideMenuItemWithSubWithLink
              to="/content/video/video-list"
              icon="youtube"
              title="Videos"
              active
            >
              <div className="menu-item cursor-pointer">
                <div
                  className="menu-link without-sub"
                  onClick={() => scroll('#kt_video_general')}
                >
                  <span className="menu-bullet">
                    <span className="bullet bullet-dot"></span>
                  </span>
                  <span className="menu-title">General</span>
                </div>
              </div>
              <div className="menu-item cursor-pointer">
                <div
                  className="menu-link without-sub"
                  onClick={() => scroll('#kt_video_distribution')}
                >
                  <span className="menu-bullet">
                    <span className="bullet bullet-dot"></span>
                  </span>
                  <span className="menu-title">Distribution</span>
                </div>
              </div>
            </AsideMenuItemWithSubWithLink>
          ) : (
            <AsideMenuItem
              to="/content/video/video-list"
              icon="youtube"
              title="Videos"
            />
          )}

          {checkSubMenu('/content/collection/') &&
          !checkSubMenu('/content/collection/collection-list') ? (
            <AsideMenuItemWithSubWithLink
              to="/content/collection/collection-list"
              icon="sort"
              title="Collections"
              active
            >
              <div className="menu-item cursor-pointer">
                <Link
                  className={clsx('menu-link without-sub', {
                    active: checkSubMenu('video-list'),
                  })}
                  to={`${window.location.pathname}/video-list`}
                >
                  <span className="menu-bullet">
                    <span className="bullet bullet-dot"></span>
                  </span>
                  <span className="menu-title">Videos</span>
                </Link>
              </div>
              <div className="menu-item cursor-pointer">
                <Link
                  className="menu-link without-sub"
                  to={`${window.location.pathname
                    .split('/')
                    .slice(0, 4)
                    .join('/')}`}
                  onClick={() => scroll('#kt_collection_general')}
                >
                  <span className="menu-bullet">
                    <span className="bullet bullet-dot"></span>
                  </span>
                  <span className="menu-title">General</span>
                </Link>
              </div>
              <div className="menu-item cursor-pointer">
                <Link
                  className="menu-link without-sub"
                  to={`${window.location.pathname
                    .split('/')
                    .slice(0, 4)
                    .join('/')}`}
                  onClick={() => scroll('#kt_collection_content')}
                >
                  <span className="menu-bullet">
                    <span className="bullet bullet-dot"></span>
                  </span>
                  <span className="menu-title">Content</span>
                </Link>
              </div>
              <div className="menu-item cursor-pointer">
                <Link
                  className="menu-link without-sub"
                  to={`${window.location.pathname
                    .split('/')
                    .slice(0, 4)
                    .join('/')}`}
                  onClick={() => scroll('#kt_collection_distribution')}
                >
                  <span className="menu-bullet">
                    <span className="bullet bullet-dot"></span>
                  </span>
                  <span className="menu-title">Distribution</span>
                </Link>
              </div>
            </AsideMenuItemWithSubWithLink>
          ) : (
            <AsideMenuItem
              to="/content/collection/collection-list"
              icon="sort"
              title="Collections"
            />
          )}
        </AsideMenuItemWithSub>
      </>
    );
  }

  return (
    <>
      {/* <AsideMenuItem
        to="/dashboard"
        icon="element-11"
        title={intl.formatMessage({ id: 'MENU.DASHBOARD' })}
      /> */}
      {/* <div className="menu-item cursor-pointer">
        <div className="menu-content pt-8 pb-2">
          <span className="menu-section text-muted text-uppercase fs-8 ls-1">
            Crafted
          </span>
        </div>
      </div> */}

      {user.role == 'admin' && (
        <>
          <AsideMenuItemWithSub
            to="/content"
            title="Content"
            icon="burger-menu"
          >
            {checkSubMenu('/content/video/') &&
            !checkSubMenu('/content/video/video-list') ? (
              <AsideMenuItemWithSubWithLink
                to="/content/video/video-list"
                icon="youtube"
                title="Videos"
                active
              >
                <div className="menu-item cursor-pointer">
                  <div
                    className="menu-link without-sub"
                    onClick={() => scroll('#kt_video_general')}
                  >
                    <span className="menu-bullet">
                      <span className="bullet bullet-dot"></span>
                    </span>
                    <span className="menu-title">General</span>
                  </div>
                </div>
                <div className="menu-item cursor-pointer">
                  <div
                    className="menu-link without-sub"
                    onClick={() => scroll('#kt_video_distribution')}
                  >
                    <span className="menu-bullet">
                      <span className="bullet bullet-dot"></span>
                    </span>
                    <span className="menu-title">Distribution</span>
                  </div>
                </div>
              </AsideMenuItemWithSubWithLink>
            ) : (
              <AsideMenuItem
                to="/content/video/video-list"
                icon="youtube"
                title="Videos"
              />
            )}

            {checkSubMenu('/content/collection/') &&
            !checkSubMenu('/content/collection/collection-list') ? (
              <AsideMenuItemWithSubWithLink
                to="/content/collection/collection-list"
                icon="sort"
                title="Collections"
                active
              >
                <div className="menu-item cursor-pointer">
                  <Link
                    className={clsx('menu-link without-sub', {
                      active: checkSubMenu('video-list'),
                    })}
                    to={`${window.location.pathname}/video-list`}
                  >
                    <span className="menu-bullet">
                      <span className="bullet bullet-dot"></span>
                    </span>
                    <span className="menu-title">Videos</span>
                  </Link>
                </div>
                <div className="menu-item cursor-pointer">
                  <Link
                    className="menu-link without-sub"
                    to={`${window.location.pathname
                      .split('/')
                      .slice(0, 4)
                      .join('/')}`}
                    onClick={() => scroll('#kt_collection_general')}
                  >
                    <span className="menu-bullet">
                      <span className="bullet bullet-dot"></span>
                    </span>
                    <span className="menu-title">General</span>
                  </Link>
                </div>
                <div className="menu-item cursor-pointer">
                  <Link
                    className="menu-link without-sub"
                    to={`${window.location.pathname
                      .split('/')
                      .slice(0, 4)
                      .join('/')}`}
                    onClick={() => scroll('#kt_collection_content')}
                  >
                    <span className="menu-bullet">
                      <span className="bullet bullet-dot"></span>
                    </span>
                    <span className="menu-title">Content</span>
                  </Link>
                </div>
                <div className="menu-item cursor-pointer">
                  <Link
                    className="menu-link without-sub"
                    to={`${window.location.pathname
                      .split('/')
                      .slice(0, 4)
                      .join('/')}`}
                    onClick={() => scroll('#kt_collection_distribution')}
                  >
                    <span className="menu-bullet">
                      <span className="bullet bullet-dot"></span>
                    </span>
                    <span className="menu-title">Distribution</span>
                  </Link>
                </div>
              </AsideMenuItemWithSubWithLink>
            ) : (
              <AsideMenuItem
                to="/content/collection/collection-list"
                icon="sort"
                title="Collections"
              />
            )}

            <AsideMenuItem
              to="/content/compilation/compilation-list"
              icon="abstract-26"
              title="Compilations"
            />

            {checkSubMenu('/content/dureel/') &&
            !checkSubMenu('/content/dureel/dureel-list') ? (
              <AsideMenuItemWithSubWithLink
                to="/content/dureel/dureel-list"
                icon="tablet"
                title="DuReels"
                active
              >
                <div className="menu-item cursor-pointer">
                  <div
                    className="menu-link without-sub"
                    onClick={() => scroll('#kt_video_general')}
                  >
                    <span className="menu-bullet">
                      <span className="bullet bullet-dot"></span>
                    </span>
                    <span className="menu-title">General</span>
                  </div>
                </div>
                <div className="menu-item cursor-pointer">
                  <div
                    className="menu-link without-sub"
                    onClick={() => scroll('#kt_video_distribution')}
                  >
                    <span className="menu-bullet">
                      <span className="bullet bullet-dot"></span>
                    </span>
                    <span className="menu-title">Distribution</span>
                  </div>
                </div>
              </AsideMenuItemWithSubWithLink>
            ) : (
              <AsideMenuItem
                to="/content/dureel/dureel-list"
                icon="tablet"
                title="DuReels"
              />
            )}

            <AsideMenuItem
              to="/content/tagging/tagging-list"
              icon="tag-cross"
              title="Tagging"
            />
            <AsideMenuItem
              to="/content/subtagging/subtagging-list"
              icon="tag-cross"
              title="Subtagging"
            />
          </AsideMenuItemWithSub>

          <AsideMenuItemWithSub to="/featured" icon="brush" title="Featured">
            <AsideMenuItem
              to="/featured/character"
              icon="people"
              title="Characters"
            />
            <AsideMenuItem to="/featured/video" icon="youtube" title="Videos" />
          </AsideMenuItemWithSub>
        </>
      )}
      <AsideMenuItemWithSub
        to="/subscribers"
        title="Subscribers"
        icon="profile-circle"
      >
        {checkSubMenu('/subscribers/users') &&
        !checkSubMenu('/subscribers/users/subscribers-list') ? (
          <AsideMenuItemWithSubWithLink
            to="/subscribers/users/subscribers-list"
            icon="profile-circle"
            title="Subscribers list"
            active
          >
            <div className="menu-item cursor-pointer">
              <div
                className={clsx('menu-link without-sub', {
                  active: checkSubMenu('overview'),
                })}
                onClick={() => changeLastPath('overview')}
              >
                <span className="menu-bullet">
                  <span className="bullet bullet-dot"></span>
                </span>
                <span>Overview</span>
              </div>
            </div>
            <div className="menu-item cursor-pointer">
              <div
                className={clsx('menu-link without-sub', {
                  active: checkSubMenu('details'),
                })}
                onClick={() => changeLastPath('details')}
              >
                <span className="menu-bullet">
                  <span className="bullet bullet-dot"></span>
                </span>
                <span className="menu-title">Details</span>
              </div>
            </div>
            <div className="menu-item cursor-pointer">
              <div
                className={clsx('menu-link without-sub', {
                  active: checkSubMenu('profile-profile'),
                })}
                onClick={() => changeLastPath('profile-profile')}
              >
                <span className="menu-bullet">
                  <span className="bullet bullet-dot"></span>
                </span>
                <span className="menu-title">Profile</span>
              </div>
            </div>
            <div className="menu-item cursor-pointer">
              <div
                className={clsx('menu-link without-sub', {
                  active: checkSubMenu('manage-content'),
                })}
                onClick={() => changeLastPath('manage-content')}
              >
                <span className="menu-bullet">
                  <span className="bullet bullet-dot"></span>
                </span>
                <span className="menu-title">Content Management</span>
              </div>
            </div>
          </AsideMenuItemWithSubWithLink>
        ) : (
          <AsideMenuItem
            to="/subscribers/users/subscribers-list"
            icon="profile-circle"
            title="Subscribers list"
          />
        )}
        <AsideMenuItem
          to="/subscribers/profile/profile-list"
          icon="profile-circle"
          title="Profile"
        />
        <AsideMenuItem
          to="/subscribers/guests/guests-list"
          icon="profile-circle"
          title="Guests list"
        />
        {/* <AsideMenuItem
          to="/content/collection/collection-list"
          icon="sort"
          title="Collections"
        />
        <AsideMenuItem
          to="/content/tag/tag-list"
          icon="tag-cross"
          title="Tagging"
        /> */}
      </AsideMenuItemWithSub>

      {user.role == 'admin' && (
        <AsideMenuItemWithSub
          to="/management"
          title="Manage Layout"
          icon="gear"
        >
          <AsideMenuItem
            to="/management/category-content/category-content-list"
            hasBullet={true}
            title="Category Content"
          />
          <AsideMenuItem
            to="/management/category-age/category-age-list"
            hasBullet={true}
            title="Category Age"
          />
          <AsideMenuItem
            to="/management/in-app-message/in-app-message-list"
            hasBullet={true}
            title="In App Message"
            active={checkSubMenu('/management/in-app-message')}
          />
          <AsideMenuItem
            to="/management/dynamic-banner/dynamic-banner-list"
            hasBullet={true}
            title="Dynamic Banner"
            active={checkSubMenu('/management/dynamic-banner')}
          />
          <AsideMenuItem
            to="/management/campaign-overlay/campaign-overlay-list"
            hasBullet={true}
            title="Campaign Overlay"
            active={checkSubMenu('/management/campaign-overlay')}
          />
          <AsideMenuItem
            to="/management/featured-banner/featured-banner-list"
            hasBullet={true}
            title="Featured Banner"
            active={checkSubMenu('/management/featured-banner/')}
          />
          <AsideMenuItem
            to="/management/featured-banner-overlay/featured-banner-overlay-list"
            hasBullet={true}
            title="Banner Overlay"
            active={checkSubMenu('/management/featured-banner-overlay')}
          />
          <AsideMenuItem
            to="/management/video-thumbnail-overlay/video-thumbnail-overlay-list"
            hasBullet={true}
            title="Thumbnail Overlay"
            active={checkSubMenu('/management/video-thumbnail-overlay')}
          />
          <AsideMenuItem
            to="/management/ui-text/ui-text-list"
            hasBullet={true}
            title="UI Text"
            active={checkSubMenu('/management/ui-text')}
          />
          <AsideMenuItem
            to="/management/special-row/special-row-list"
            hasBullet={true}
            title="Special Row"
            active={checkSubMenu('/management/special-row')}
          />
          {checkSubMenu(`/management/home-button/`) &&
          checkSubMenu(`/home-button-details/`) &&
          !checkSubMenu('/management/home-button/home-button-list') ? (
            <AsideMenuItemWithSubWithLink
              to="/management/home-button/home-button-list"
              hasBullet={true}
              title="Home Button"
              active
            >
              <div className="menu-item cursor-pointer">
                <Link
                  className={clsx('menu-link without-sub', {
                    active: checkSubMenu('collections-list'),
                  })}
                  to={`${window.location.pathname}/collections-list`}
                >
                  <span className="menu-bullet"></span>
                  <span className="menu-title">Collections</span>
                </Link>
              </div>
              <div className="menu-item cursor-pointer">
                <Link
                  className={clsx('menu-link without-sub', {
                    active: !checkSubMenu('collections-list'),
                  })}
                  to={`${window.location.pathname
                    .split('/')
                    .slice(0, 6)
                    .join('/')}`}
                >
                  <span className="menu-bullet"></span>
                  <span className="menu-title">Details</span>
                </Link>
              </div>
            </AsideMenuItemWithSubWithLink>
          ) : (
            <AsideMenuItem
              to="/management/home-button/home-button-list"
              hasBullet={true}
              title="Home Button"
              active={checkSubMenu('/management/home-button')}
            />
          )}
          <AsideMenuItem
            to="/management/onboarding-screen/onboarding-screen-list"
            hasBullet={true}
            title="Onboarding Screens"
          />
          <AsideMenuItemWithSub
            to="/management/navigation"
            title="Navigation"
            hasBullet={true}
          >
            <AsideMenuItem
              to="/management/top-navigation/top-navigation-list"
              title="Top Navigation"
              icon="profile-circle"
            />
          </AsideMenuItemWithSub>
          <AsideMenuItem
            to="/management/recommender-row/recommender-row-list"
            hasBullet={true}
            title="Recommender Rows"
          />
          <AsideMenuItem
            to="/management/report-mrr/report-mrr-list"
            hasBullet={true}
            title="MRR"
          />
          <AsideMenuItem
            to="/management/pre-roll/pre-roll-list"
            hasBullet={true}
            title="Pre Roll"
          />
          <AsideMenuItem
            to="/management/post-roll/post-roll-list"
            hasBullet={true}
            title="Post Roll"
          />
          <AsideMenuItem
            to="/management/game/game-list"
            hasBullet={true}
            title="Game"
          />
          <AsideMenuItem
            to="/management/geo-region/geo-region-list"
            hasBullet={true}
            title="Region Geo Block"
          />
          <AsideMenuItem
            to="/management/outside-links"
            hasBullet={true}
            title="Outside Link"
          />
          <AsideMenuItem
            to="/management/settings"
            hasBullet={true}
            title="Setting"
          />
          <AsideMenuItemWithSub
            to="/management/team"
            title="Team"
            hasBullet={true}
          >
            <AsideMenuItem
              to="/management/team/avatar/avatar-list"
              title="Avatar"
              icon="profile-circle"
            />
            {/* <AsideMenuItem
            to="/crafted/pages/profile/connections"
            title="Connections"
            hasBullet={true}
          /> */}
          </AsideMenuItemWithSub>
          <AsideMenuItem
            to="/management/collection-top/collection-top-list"
            hasBullet={true}
            title="Top 10 Collection"
          />
          <AsideMenuItem
            to="/management/bubble-info/bubble-info-list"
            hasBullet={true}
            title="Bubble Info"
          />
          <AsideMenuItem
            to="/management/transcoder/transcoder-list"
            hasBullet={true}
            title="Transcoder"
          />
          <AsideMenuItem
            to="/management/label/label-list"
            hasBullet={true}
            title="Channel Labelling"
          />
        </AsideMenuItemWithSub>
      )}

      {user.role == 'admin' && (
        <AsideMenuItemWithSub
          to="/manage-growth"
          title="Manage Growth"
          icon="gear"
        >
          <AsideMenuItem
            to="/manage-growth/promo-banners/promo-banners-list"
            hasBullet={true}
            title="Promo Banners"
          />
          <AsideMenuItem
            to="/manage-growth/duri-images"
            hasBullet={true}
            title="Duri Images"
          />
        </AsideMenuItemWithSub>
      )}

      <AsideMenuItem
        to="/licensor-rev-shares-list"
        icon="dollar"
        title="Licensor Rev Shares"
      />

      <AsideMenuItem to="/ab-tests" icon="chart-simple" title="A/B Tests" />

      <AsideMenuItem to="/video-ads" icon="tablet-text" title="Video Ads" />

      <AsideMenuItemWithSub to="/analytics" icon="chart" title="Analytics">
        <AsideMenuItem
          to="/analytics/viewerships"
          icon="youtube"
          title="Viewership"
        />
      </AsideMenuItemWithSub>
      {/* <AsideMenuItem to="/reports" icon="chart-line" title="Reports" /> */}
    </>
  );
}
